/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum SendProspectEmails200SkippedItemReason {
  no_draft = 'no_draft',
  changed = 'changed',
  not_contactable = 'not_contactable',
  already_queued = 'already_queued',
  other_sender = 'other_sender'
}
